import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class DistrictSelector extends SelectorBaseViewModel<district>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    protected async loadData(): Promise<district[]> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/DistrictManipulationServices/GetAllDistricts',{
            });
            return result.Districts.map(x=>{
                let r = new district(this);
                r.id=x.Id;
                r.title = x.DistrictName;
                return r;
            })
        } catch (ex) {
            console.log(ex);
            return Promise.resolve<district[]>([]);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class district extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}